import styled from 'styled-components';
import { FlexRow } from '@make-software/tg-mini-app-ui';

export const ImageRow = styled(FlexRow)(({ theme }) =>
  theme.withMedia({
    marginBottom: '16px',
    width: '100%',
    height: 0,
    paddingBottom: 'calc(0.5 * 100%)',
    position: 'relative'
  })
);

export const StyledBanner = styled.img(({ theme }) =>
  theme.withMedia({
    position: 'absolute',
    top: '0',
    left: '0',
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    borderRadius: '8px',
    border: '1px solid #41424E'
  })
);
